
import StorefrontIcon from '@mui/icons-material/Storefront';

import PaidIcon from '@mui/icons-material/Paid';
import { Roles } from "data/authData";

export const eboStoreExpensesRoleAccess = (user) => {
	let roles = "VIEWER";
	const rolesArray = Roles.map((role) => role.key);

	if (user?.role?.ADMIN) {
		roles = "ADMIN";
	} else {
		Object.keys(user?.role || {}).forEach((role) => {
			if (rolesArray.includes(role)) {
				roles = role;
			}
		});
	}

	return { roles };
};

export const canDownloadEboStoreExpenses = (role) =>
	["EDITOR", "PUBLISHER", "ADMIN"].includes(role);

export const eboStoreExpensesServices = {
    masters: {
        name: "EBO Expenses",
        key: "ebo_store_expenses",
        display: true,
        icon: <StorefrontIcon />,
        types: {
            dashboard: {
                name: "Dashboard",
                key: "dashboard",
                display: true,
                icon: <PaidIcon />,
            },
        },
    },
};
